import AccountForm from './AccountForm';
import { Box } from '@chakra-ui/react';
import { Client } from '@opanuj/shared/types';
import { clientUpdate } from '../../../operations/client/clientUpdate';
import { useDatabase } from '../../../hooks/useDatabase';
import { useFirebaseAuth } from '../../../hooks/useFirebaseAuth';
import { useUpdateEmail, useUpdateProfile } from 'react-firebase-hooks/auth';

export type AccountViewProps = {
	client: Client;
}

const AccountView = ({ client }: AccountViewProps) => {
	const database = useDatabase()
	const auth = useFirebaseAuth();
	const [updateProfile] = useUpdateProfile(auth);
	const [updateEmail] = useUpdateEmail(auth);

	const handleUpdate = async (values: Partial<Client>): Promise<void> => {
		return clientUpdate(database, { values, client, updateProfile, updateEmail })
	}

	return (
		<Box>
			<AccountForm client={client} onUpdate={handleUpdate} />
		</Box>
	);
}

export default AccountView;